import { useEffect, useState } from "react";
import { lineColors } from "./helpers";
import { Spin } from "antd";
import { LineGraph } from "components/line-graph";
import { ConditionalRenderer } from "components/conditonal-renderer";
import styles from "./style.module.scss";
import { BarChartV1 } from "components/bar-chart-v1";

interface HourlyData {
  [hour: string]: {
    [key: string]: number;
  };
}

const ChartToggleButtons = ({
  onChartTypeClick,
  OnTypeClick,
  type,
  chartType,
}: any) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
      }}
    >
      <div>
        <span style={{ marginRight: "5px", marginTop: "5px" }}>
          <img
            src="/assets/icons/radioIcon.svg"
            alt="Icon"
            style={{ verticalAlign: "middle" }}
          />
        </span>
        <button
          className={
            chartType === "line"
              ? styles.toggleButtonsActive
              : styles.toggleButtonsInactive
          }
          onClick={() => onChartTypeClick("line")}
        >
          <img
            src="/assets/icons/lineChart.svg"
            alt="Icon"
            style={{ marginRight: "5px" }}
          />
          Line Chart
        </button>
        <button
          className={
            chartType === "bar"
              ? styles.toggleButtonsActive
              : styles.toggleButtonsInactive
          }
          onClick={() => onChartTypeClick("bar")}
        >
          <img
            src="/assets/icons/barChart.svg"
            alt="Icon"
            style={{ marginRight: "5px" }}
          />
          Stacked Bar Chart
        </button>
      </div>
      <div>
        <span style={{ marginRight: "5px", marginTop: "5px" }}>
          <img
            src="/assets/icons/radioIcon.svg"
            alt="Icon"
            style={{ verticalAlign: "middle" }}
          />
        </span>
        <button
          className={
            type === "individual"
              ? styles.toggleButtonsActive
              : styles.toggleButtonsInactive
          }
          onClick={() => OnTypeClick("individual")}
        >
          <img
            src="/assets/icons/individual.svg"
            alt="Icon"
            style={{ verticalAlign: "middle" }}
          />
          Individual
        </button>
        <button
          className={
            type === "all"
              ? styles.toggleButtonsActive
              : styles.toggleButtonsInactive
          }
          onClick={() => OnTypeClick("all")}
        >
          Combined
        </button>
      </div>
    </div>
  );
};

export function Graphs({ data, labels, timeInterval, metrics }: any) {
  const [serverKeys, setServerKeys] = useState<any>();
  const [chartType, setChartType] = useState("bar");
  const [type, setType] = useState("individual");
  const [graphData, setGraphData] = useState<any>(null);
  const [allServerCountData, setAllServerCountData] = useState<any>(null);
  const [allServerAveragesCount, setAllServerAverageData] = useState<any>(null);
  const [proccessingTimeData, setProcessingTimeData] = useState<any>(null);
  useEffect(() => {
    const insertLabelsForAllServers = () => {
      const allServersData = data; // Assuming data contains all server data
      const servers = Object.keys(allServersData); // Extracting server names

      const updatedData: any = {};
      const mergedData: any = [];
      const mergedDataTime: any = [];

      if (Object.keys(allServersData).length === 0) {
        // If data is empty, set all values to zero
        const zeroData = labels.map((label: any) => ({
          timeStamps: label,
          ...servers.reduce(
            (acc, server) => ({
              ...acc,
              [server]: 0,
            }),
            {}
          ),
        }));

        // Set state variables with zero data
        setProcessingTimeData(zeroData);
        setAllServerAverageData(zeroData);
        setAllServerCountData(zeroData);
        setGraphData(zeroData);

        // Return to exit the function early
        return;
      }

      servers.forEach((server: string) => {
        const serverData = allServersData[server];
        const newData = serverData;

        newData.forEach((dataPoint: any) => {
          dataPoint.server = server;
        });
        labels.forEach((label: any) => {
          const labelTimestamp = new Date(label).getTime();

          let indexToInsert = newData.findIndex(
            (dataPoint: any) =>
              new Date(dataPoint.uploaded_time).getTime() > labelTimestamp
          );

          if (indexToInsert === -1) {
            // Label goes at the end
            indexToInsert = newData.length;
          }

          let countValue = 0;
          let timeValue = 0;

          if (indexToInsert > 0) {
            countValue = newData[indexToInsert - 1].count;
          }

          newData.splice(indexToInsert, 0, {
            count: countValue,
            uploaded_time: label,
            server: server,
            processing_time: timeValue,
          });
          countValue++;
        });

        updatedData[server] = newData;
      });

      servers.forEach((server: string) => {
        const serverData = updatedData[server];
        serverData.forEach((dataPoint: any) => {
          const { count, uploaded_time, processing_time } = dataPoint;
          const serverCountKey = server;

          const mergedObject: any = {
            time: uploaded_time,
            [serverCountKey]: count,
          };

          const processingTimeObject: any = {
            time: uploaded_time,
            [serverCountKey]: processing_time,
          };

          // Check if there's already an object with the same time in the mergedData array
          const existingObjectIndex = mergedData.findIndex(
            (obj: any) => obj.time === uploaded_time
          );

          if (existingObjectIndex !== -1) {
            // If an object with the same time exists, update its count value for the current server
            mergedData[existingObjectIndex][serverCountKey] = count;
            mergedDataTime[existingObjectIndex][serverCountKey] =
              processing_time;
          } else {
            // If no object with the same time exists, push a new mergedObject into the mergedData array
            mergedData.push(mergedObject);
            mergedDataTime.push(processingTimeObject);
          }
        });
      });
      mergedData.sort(
        (a: any, b: any) =>
          new Date(a.time).getTime() - new Date(b.time).getTime()
      );

      mergedDataTime.sort(
        (a: any, b: any) =>
          new Date(a.time).getTime() - new Date(b.time).getTime()
      );

      for (let i = 1; i < mergedData.length; i++) {
        servers.forEach((server: string) => {
          const serverCountKey = server;
          if (!mergedData[i][serverCountKey]) {
            mergedData[i][serverCountKey] = mergedData[i - 1][serverCountKey];
          }
        });
      }

      const intervalsArray = createIntervalsAndCalculateCounts(mergedData);

      const test = createIntervalsAndCalculateCountss(mergedData);

      const finalArray = createIntervalsArray(test);
      const processingTimeIndivdiual = aggregateValuesTimes(
        mergedDataTime,
        labels
      );
      const averageProcessingTimeIndividual = calculateAverageProcessingTime(
        finalArray,
        processingTimeIndivdiual
      );
      const allServerCountArray = aggregateData(finalArray, true);
      const averageProcessingTimeSum = calculateAverageProcessingTimeOfTotal(
        allServerCountArray,
        processingTimeIndivdiual
      );
      const allServerAveragesCount = aggregateData(
        averageProcessingTimeIndividual,
        true
      );
      const serverskeys = Object.keys(mergedData[0]).filter(
        (key) => key !== "time"
      );
      setProcessingTimeData(averageProcessingTimeIndividual);
      setAllServerAverageData(averageProcessingTimeSum);
      setAllServerCountData(allServerCountArray);
      setServerKeys(serverskeys);
      setGraphData(finalArray);
      // mergeData(updatedDataForRecharts);
    };

    insertLabelsForAllServers();
  }, [data]);

  // Function to parse the time string into a Date object
  const parseTime = (timeStr: any) => new Date(timeStr);

  const createIntervalsAndCalculateCounts = (data: any) => {
    const intervals = [];
    let currentIndex = 0;

    while (currentIndex < data.length) {
      const startTime = parseTime(data[currentIndex]?.time);

      let endTime = new Date(startTime.getTime() + 2 * 60 * 60 * 1000);
      if (timeInterval === "4 hrs") {
        endTime = new Date(startTime.getTime() + 15 * 60 * 1000);
      } else if (timeInterval === "1 hr") {
        endTime = new Date(startTime.getTime() + 5 * 60 * 1000);
      } else if (timeInterval === "8 hrs") {
        endTime = new Date(startTime.getTime() + 30 * 60 * 1000);
      } else if (timeInterval === "12 hrs") {
        endTime = new Date(startTime.getTime() + 30 * 60 * 1000);
      } else if (timeInterval === "1 day") {
        endTime = new Date(startTime.getTime() + 60 * 60 * 1000);
      } else if (timeInterval === "3 days") {
        endTime = new Date(startTime.getTime() + 180 * 60 * 1000);
      } else if (timeInterval === "1 week") {
        endTime = new Date(startTime.getTime() + 1440 * 60 * 1000);
      }
      let nextIndex = currentIndex + 1;
      let nextIndex2 = currentIndex + 1;
      // Find the index of the exact match for endTime

      while (
        nextIndex < data.length &&
        parseTime(data[nextIndex].time).getTime() !== endTime.getTime()
      ) {
        nextIndex++;
        nextIndex2++;
      }

      if (nextIndex >= data.length) {
        // No exact match, find the closest time index

        nextIndex = data.length - 1;
        endTime = parseTime(data[nextIndex]?.time);
      }

      const keys = Object.keys(data[nextIndex]).filter((key) => key !== "time");

      // Calculate counts by subtracting counts at currentIndex from counts at nextIndex
      const totalCounts: Record<string, number> = {};
      keys.forEach((key) => {
        totalCounts[key] = data[nextIndex][key] - data[currentIndex][key];
      });

      const startAdjusted = new Date(startTime);
      startAdjusted.setSeconds(0);

      const endAdjusted = new Date(endTime);
      endAdjusted.setSeconds(0);

      if (startAdjusted.getTime() !== endAdjusted.getTime()) {
        // Add the interval and total counts to the result array
        intervals.push({
          startTime: startTime,
          endTime: endTime,
          totalCounts: totalCounts,
        });
      }

      currentIndex = nextIndex2;
    }

    return intervals;
  };

  function convertDateFormat(dateString: any) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const createIntervalsAndCalculateCountss = (data: any) => {
    const intervals = [];
    let currentIndex = 0;
    let count = 1;

    while (currentIndex < data.length) {
      let startTime = convertDateFormat(data[currentIndex]?.time);
      let endTime = labels[count];

      let nextIndex = currentIndex + 1;
      let nextIndex2 = currentIndex + 1;
      // Find the index of the exact match for endTime

      while (nextIndex < data.length && data[nextIndex].time !== endTime) {
        nextIndex++;
        nextIndex2++;
      }

      if (nextIndex >= data.length) {
        // No exact match, find the closest time index

        nextIndex = data.length - 1;
        endTime = data[nextIndex]?.time;
      }

      const keys = Object.keys(data[nextIndex]).filter((key) => key !== "time");

      // Calculate counts by subtracting counts at currentIndex from counts at nextIndex
      const totalCounts: Record<string, number> = {};
      keys.forEach((key) => {
        totalCounts[key] = data[nextIndex][key] - data[currentIndex][key];
      });

      const startAdjusted = new Date(startTime);
      startAdjusted.setSeconds(0);

      const endAdjusted = new Date(endTime);
      endAdjusted.setSeconds(0);

      if (startTime !== endTime) {
        // Add the interval and total counts to the result array
        intervals.push({
          startTime: startTime,
          endTime: endTime,
          totalCounts: totalCounts,
        });
      }

      currentIndex = nextIndex2;
      count++;
    }

    return intervals;
  };

  const createIntervalsArray = (intervals: any) => {
    const result: any = [];
    const resultForProcessing: any = [];

    if (intervals.length === 0) {
      return result;
    }
    // Initialize an object to store counts for each server
    const serverCounts: Record<string, number> = {};
    const processingTimes: Record<string, number> = {};

    // Iterate over the keys of the totalCounts object in the first interval
    const initialCounts = intervals[0].totalCounts;
    for (const key in initialCounts) {
      if (Object.prototype.hasOwnProperty.call(initialCounts, key)) {
        serverCounts[key] = 0; // Initialize counts to 0 for each server
      }
    }

    // Push the startTime of the first interval with counts as 0

    const originalTime = new Date(
      new Date(intervals[0].startTime).toISOString()
    );

    // Extract time components
    const hours = originalTime.getHours();
    const minutes = originalTime.getMinutes();
    const seconds = originalTime.getSeconds();

    // Extract date components
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[originalTime.getMonth()];
    const day = originalTime.getDate();
    const year = originalTime.getFullYear();

    // Construct formatted string
    const formattedString = `${month} ${day} ${year} ${hours}:${minutes}:${seconds}`;

    result.push({
      timeStamps: formattedString,
      ...serverCounts, // Spread the serverCounts object to include counts for each server
    });

    // Iterate through intervals and add the endTime with counts
    for (let i = 0; i < intervals.length; i++) {
      const interval = intervals[i];

      const originalTime = new Date(new Date(interval.endTime).toISOString());

      // Extract time components
      const hours = originalTime.getHours();
      const minutes = originalTime.getMinutes();
      const seconds = originalTime.getSeconds();

      // Extract date components
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[originalTime.getMonth()];
      const day = originalTime.getDate();
      const year = originalTime.getFullYear();

      // Construct formatted string
      const formattedString = `${month} ${day} ${year} ${hours}:${minutes}:${seconds}`;

      result.push({
        timeStamps: formattedString,
        ...interval.totalCounts, // Spread the totalCounts object to include counts for each server
      });
    }

    return result;
  };

  function aggregateData(originalArray: any, flag: any) {
    const aggregatedArray: any = [];

    originalArray.forEach((entry: any) => {
      const timeStamps = flag ? entry.timeStamps : entry.time;
      const sumAllServers = Object.values(entry).reduce(
        (acc: any, curr: any) => {
          if (typeof curr === "number") {
            return acc + curr;
          }
          return acc;
        },
        0
      );

      const newData = { timeStamps, AllServers: sumAllServers };

      aggregatedArray.push(newData);
    });

    return aggregatedArray;
  }

  function aggregateValuesTimes(inputArray: any, labelsArray: any) {
    const outputArray: any = [];

    // Finding the index of the first label in the input array
    let startIndex = -1;
    for (let i = 0; i < inputArray.length; i++) {
      if (inputArray[i].time === labelsArray[0]) {
        startIndex = i;
        break;
      }
    }

    if (startIndex === -1) {
      return outputArray;
    }

    // Pushing the first label without summing values
    outputArray.push({
      time: labelsArray[0],
      ...inputArray[startIndex],
    });

    // Now continue with the rest of the labels
    for (let i = 1; i < labelsArray.length; i++) {
      const prevTime = new Date(outputArray[i - 1].time);
      const currentTime = new Date(labelsArray[i]);
      let sumValues: any = {};

      // Summing values for the time period between current and previous label
      for (let j = startIndex; j < inputArray.length; j++) {
        const recordTime = new Date(inputArray[j].time);
        if (recordTime >= currentTime) break; // Break if record time is greater than or equal to current time
        if (recordTime >= prevTime && recordTime < currentTime) {
          for (const key in inputArray[j]) {
            if (key !== "time") {
              sumValues[key] = (sumValues[key] || 0) + inputArray[j][key];
            }
          }
        }
      }

      // Adding sumValues to outputArray
      outputArray.push({
        time: labelsArray[i],
        ...sumValues,
      });
    }

    return outputArray;
  }

  function aggregateValuesTimesSum(inputArray: any, labelsArray: any) {
    const outputArray: any = [];

    // Finding the index of the first label in the input array
    let startIndex = -1;
    for (let i = 0; i < inputArray.length; i++) {
      if (inputArray[i].time === labelsArray[0]) {
        startIndex = i;
        break;
      }
    }

    if (startIndex === -1) {
      return outputArray;
    }

    // Pushing the first label without summing values
    outputArray.push({
      time: labelsArray[0],
      ...inputArray[startIndex],
    });

    // Now continue with the rest of the labels
    for (let i = 1; i < labelsArray.length; i++) {
      const prevTime = new Date(outputArray[i - 1].time);
      const currentTime = new Date(labelsArray[i]);
      let sumValues: any = {};

      // Summing values for the time period between current and previous label
      for (let j = startIndex; j < inputArray.length; j++) {
        const recordTime = new Date(inputArray[j].time);
        if (recordTime >= currentTime) break; // Break if record time is greater than or equal to current time
        for (const key in inputArray[j]) {
          if (key !== "time") {
            sumValues[key] = (sumValues[key] || 0) + inputArray[j][key];
          }
        }
      }

      // Adding sumValues to outputArray
      outputArray.push({
        time: labelsArray[i],
        ...sumValues,
      });
    }

    return outputArray;
  }

  function calculateAverageProcessingTime(countsArray: any, timesArray: any) {
    const averageArray: any = [];

    for (let i = 0; i < timesArray.length; i++) {
      const timestamp = timesArray[i]?.time; // Add null check for timesArray[i]
      const averages: any = {};

      for (const key in timesArray[i]) {
        if (key !== "time") {
          const count = countsArray[i]?.[key] || 0; // Add null check for countsArray[i]
          const processingTime = timesArray[i]?.[key] || 0; // Add null check for timesArray[i]
          const averageTime = count === 0 ? 0 : processingTime / count;
          averages[key] = averageTime;
        }
      }

      averageArray.push({
        timeStamps: timestamp || 0, // Default to 0 if timestamp is undefined
        ...averages,
      });
    }

    return averageArray;
  }

  function sumProcessingTimes(obj: any) {
    // Check if obj is an object
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      console.error("Input is not an object");
      return {};
    }

    let sum = 0;

    // Iterate over the keys of the object
    Object.keys(obj).forEach((key: string) => {
      // Check if the key is not 'time' and the value is a number
      if (key !== "time" && typeof obj[key] === "number") {
        sum += obj[key];
      }
    });

    return sum;
  }

  function calculateAverageProcessingTimeOfTotal(
    countsArray: any,
    timesArray: any
  ) {
    const sumArray: any = [];
    const averageArray: any = [];

    timesArray.forEach((timeObject: any) => {
      // Sum up processing times for the current timestamp
      const totalProcessingTimes = sumProcessingTimes(timeObject);
      // Push the sum of processing times into the averageArray
      sumArray.push({
        timeStamps: timeObject.time,
        totalProcessingTime: totalProcessingTimes,
      });
    });

    for (let i = 0; i < countsArray.length; i++) {
      // Get the count and times for the current index
      const count = countsArray[i].AllServers;
      const time = sumArray[i].totalProcessingTime;

      const average = count !== 0 ? time / count : 0;

      averageArray.push({
        timeStamps: countsArray[i].timeStamps,
        AllServers: average,
      });
    }
    return averageArray;
  }

  if (!graphData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Spin />
      </div>
    );
  }

  const handleChartTypeClick = (value: any) => {
    setChartType(value);
  };

  const handleTypeClick = (value: any) => {
    setType(value);
  };

  const allData =
    metrics === "Processing Time" ? allServerAveragesCount : allServerCountData;

  const individualData =
    metrics === "Processing Time" ? proccessingTimeData : graphData;
  const graphHeight = window.innerWidth < 1600 ? "300px" : "350px";
  return (
    <div style={{ minHeight: graphHeight, height: graphHeight }}>
      <ChartToggleButtons
        onChartTypeClick={handleChartTypeClick}
        OnTypeClick={handleTypeClick}
        chartType={chartType}
        type={type}
      />
      <p className={styles.title}>{metrics} Chart</p>
      <ConditionalRenderer condition={chartType === "bar" && type === "all"}>
        <BarChartV1
          data={allData}
          lineColors={lineColors}
          serverKeys={["AllServers"]}
          type={"All"}
          metrics={metrics}
          timeInterval={timeInterval}
        />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={chartType === "line" && type === "individual"}
      >
        <LineGraph
          graphData={individualData}
          serverKeys={serverKeys}
          lineColors={lineColors}
          timeInterval={timeInterval}
          metrics={metrics}
        />
      </ConditionalRenderer>

      <ConditionalRenderer condition={chartType === "line" && type === "all"}>
        <LineGraph
          graphData={allData}
          serverKeys={["AllServers"]}
          lineColors={lineColors}
          timeInterval={timeInterval}
          type={"All"}
          metrics={metrics}
        />
      </ConditionalRenderer>

      <ConditionalRenderer
        condition={chartType === "bar" && type === "individual"}
      >
        <BarChartV1
          data={individualData}
          lineColors={lineColors}
          serverKeys={serverKeys}
          timeInterval={timeInterval}
          metrics={metrics}
        />
      </ConditionalRenderer>
    </div>
  );
}
